import {
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'axis-aqi',
  templateUrl: './aqi.component.html',
  host: {
    class: 'axis-aqi'
  }
})
export class AQIComponent implements OnInit {
  @Input() public label: string;
  @Input('data-tier') public tier: string;
  @Input() public type: string;

  public ngOnInit(): any {}
}
